const initSelectResize = () => {
    document.querySelectorAll('.resizeselect').forEach($el => {
        new SelectResize($el);
    });
};

/**
 * @param {HTMLElement}                  $el                    Conteneur
 * @param {HTMLFormElement}              $categoriesSelectsForm Formulaire de sélection des catégorie
 * @param {NodeList.<HTMLSelectElement>} $categoriesSelects     Inputs de selection des catégories
 * @param {HTMLFormElement}              $searchForm            Formulaire de recherche
 * @param {HTMLElement}                  $ajaxContent           Element contenant les posts
 */

class SelectResize {
    constructor($el) {
        this.$el = $el;
        const $This = this;
        this.$el.addEventListener('change', function() {
            $This.resizeSelect(this);
        });
        this.resizeSelect(this.$el);
    }
    resizeSelect(element) {
        // console.log( 'resizeSelect => ' + element.getAttribute('data-title') );
        const $this = element;
  
        // get font-weight, font-size, and font-family
        const style = window.getComputedStyle($this);
        const { fontWeight, fontSize, fontFamily } = style;

        // create test element
        const text = $this.options[$this.selectedIndex].text;
        const $test = $('<span>').html(text).css({
            'font-size': fontSize,
            'font-weight': fontWeight,
            'font-family': fontFamily,
            'text-transform': 'uppercase',
            visibility: 'hidden', // prevents FOUC
        });

        // add to body, get width, and get out
        $test.appendTo($this.parentNode);
        
        const width = $test[0].offsetWidth + 20 + 33; // 20 padding for the arrow + 25 adjusting
        $test.remove();
        // set select width
        $this.style.width = width + 'px';
    }
}

export { initSelectResize as default, SelectResize};